import React, { useEffect, useState } from "react";

import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { forgotPassword } from "../../slices/thunks";
import logo from "../../assets/images/logo.png";
import { Alert, Form, FormFeedback, Input, Label, Spinner } from "reactstrap";
import { useNavigate } from "react-router-dom";
import Banner from "./AuthBanner";

const ForgotPassword = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState(null);
  const [alertMessage, setAlertMessage] = useState(null);

  const loading = useSelector((state) => state.forgetPassword.loading);

  const forgotErrorMessage = useSelector(
    (state) => state.forgetPassword.forgetError
  );

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Enter a valid email address.")
        .required("email field is required."),
    }),
    onSubmit: async (values) => {
    try {
        const data = {
          email: values.email,
          reset_password: true
        }
        const res = await dispatch(forgotPassword(data));
  
        if (res?.message) {
          setAlertMessage(res?.message);
          setAlertType("success");
          setShowAlert(true);
          setTimeout(() => {
            setShowAlert(false);
            navigate(`/verify-code?register=false&otp=null&email=${values.email}`);
          }, 3000);
        } else {
          setAlertMessage(forgotErrorMessage);
          setAlertType("danger");
          setShowAlert(true);
        }
    } catch (error) {
      console.log("error", error);
      
    }

    },
  });


  document.title = "Forgot Password | D&A";

  return (
    <React.Fragment>
      <div className="loginPage">
        <Banner />

        <div className="loginWrapper">
          <div className="loginContent">
            {showAlert && (
              <Alert
                color={alertType}
                toggle={() => setShowAlert(false)}
                fade={true}
              >
                {alertMessage}
              </Alert>
            )}

            <div className="headerText">
              <img
                loading="lazy"
                className="logoImage"
                src={logo}
                alt="Company logo"
              />
              <h1 className="welcomeBack">Forgot Password ?</h1>
              <p className="loginInstructions">
                Enter your email address and we’ll send you a link to reset your
                password.
              </p>
            </div>

            <Form
              className="loginForm"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
              action="#"
            >
              <div className="inputField">
                <Label htmlFor="email" className="inputLabel">
                  Email
                </Label>
                <Input
                  name="email"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.email || ""}
                  className="form-control textInput"
                  type="email"
                  id="email"
                  placeholder="Enter your email"
                  invalid={
                    validation.touched.email && validation.errors.email
                      ? true
                      : false
                  }
                />
                {validation.touched.email && validation.errors.email ? (
                  <FormFeedback type="invalid">
                    {validation.errors.email}
                  </FormFeedback>
                ) : null}
              </div>

              <button type="submit" className="signInButton" aria-label="Send reset code">
                {loading ? <Spinner /> : "Send Code"}
              </button>

              <div className="d-flex align-items-center mx-auto mt-4 gap-1">
                <p
                  className="signUpPrompt cursor-pointer"
                  onClick={() => {
                    navigate("/login");
                  }}
                >
                  Back to Login{" "}
                </p>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ForgotPassword;
